import { PlantDetailContainer } from '@containers'

const PlantDetailPage = () => {
  return <PlantDetailContainer />
}

export default PlantDetailPage
